/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetAutomationQueryResponse,
  GetAutomationPathParams,
  GetAutomation404,
} from '../../types/GetAutomation'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getAutomation } from '../../clients/getAutomation'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAutomationQueryKey = ({
  id,
}: {
  id: GetAutomationPathParams['id']
}) =>
  [{ url: '/api/v1/automations/automations/:id/', params: { id: id } }] as const

export type GetAutomationQueryKey = ReturnType<typeof getAutomationQueryKey>

export function getAutomationQueryOptions(
  { id }: { id: GetAutomationPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getAutomationQueryKey({ id })
  return queryOptions<
    GetAutomationQueryResponse,
    ResponseErrorConfig<GetAutomation404>,
    GetAutomationQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getAutomation(
        { id: id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description ViewSet for managing automations.
 * Provides CRUD operations for automations with different serializers
 * for list, detail, and create/update operations.
 * @summary Get automation detail
 * {@link /api/v1/automations/automations/:id/}
 */
export function useGetAutomation<
  TData = GetAutomationQueryResponse,
  TQueryData = GetAutomationQueryResponse,
  TQueryKey extends QueryKey = GetAutomationQueryKey,
>(
  { id }: { id: GetAutomationPathParams['id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetAutomationQueryResponse,
        ResponseErrorConfig<GetAutomation404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getAutomationQueryKey({ id })

  const query = useQuery(
    {
      ...getAutomationQueryOptions({ id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetAutomation404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
